import { Base } from '@studiometa/js-toolkit';

/**
 * CollectionLinks component
 */
export default class Baseline extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Baseline',
  };

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   */
  scrolled({ y }) {
    if (y > 10) {
      this.$el.classList.add('fadeout');
      this.$destroy();
    }
  }
}
